import React, { useEffect, useState, useRef } from "react";
import { Outlet } from "react-router-dom";
import useAuth from "../hooks/useAuth";
import useAxiosPrivate from "../hooks/useAxiosPrivate";
import useRefreshToken from "../hooks/useRefreshToken";
import CircularProgress from "@mui/material/CircularProgress";
import Box from "@mui/material/Box";
import { useLocation } from "react-router-dom";
import axios from "axios";
import { API_ROUTES } from "../utils/constants";

export default function PersistLogin() {
  const refresh = useRefreshToken();
  const { accessToken, setUser, isLoading, user } = useAuth();
  const [loading, setLoading] = useState(true);
  const axiosPrivate = useAxiosPrivate();
  const location = useLocation();
  const hasVerifiedUser = useRef(false);

  useEffect(() => {
    let isMounted = true;

    const verifyUser = async () => {
      if (
        hasVerifiedUser.current ||
        (accessToken && Object.keys(user || {}).length > 0)
      ) {
        setLoading(false);
        return;
      }

      try {
        if (location.pathname === "/sign-in") {
          throw new Error("Already on sign-in page");
        }

        let userData = null;

        if (accessToken) {
          try {
            const response = await axios.get(`${API_ROUTES.BASE_URL}/user`, {
              headers: {
                Authorization: `Bearer ${accessToken}`,
              },
              withCredentials: true,
            });
            userData = response.data;
          } catch (error) {
            console.error(
              "Access token invalid, attempting refresh:",
              error.message
            );
            const refreshResult = await refresh();
            if (!refreshResult) {
              console.error(
                "Refresh failed, waiting for auth-context to restore"
              );
              setLoading(false);
              return;
            }
            const { data } = await axiosPrivate.get("user");
            userData = data;
          }
        } else if (Object.keys(user || {}).length > 0) {
          setLoading(false);
          return;
        } else {
          setLoading(false);
          return;
        }

        if (isMounted && userData) {
          setUser(userData);
          hasVerifiedUser.current = true;
        }
      } catch (error) {
        setLoading(false);
      } finally {
        if (isMounted) {
          setLoading(false);
        }
      }
    };

    if (!isLoading) {
      verifyUser();
    } else {
      setLoading(false);
    }

    return () => {
      isMounted = false;
    };
  }, [accessToken, isLoading, refresh, user]);

  return loading ? (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
      }}
    >
      <CircularProgress color="info" />
    </Box>
  ) : (
    <Outlet />
  );
}
